import React, { useState, useEffect } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { Field, Form } from "react-jsonschema-form-validation";
import {
	resetUserSettings,
	getUserPid,
	saveYourControl,
} from "../../../services/userService";
import { schema } from "../YourControl";
import { HelpPopup } from "../../../components/HelpPopup";
import { HelpButtonExpanded } from "../../../components/common/HelpButtonExpanded";

import { pathRoot } from "../YourControl";

export function Page2({ yourControlSettings, companionStartDate, ...props }) {
	// -- Required for Day of Week selector
	// const [dayOfWeek, setDayOfWeek] = useState(yourControlSettings.dayOfWeek ?? null);
	const [experienceOffset] = useState(
		yourControlSettings.experienceOffset ?? null
	);
	const [isShowingCostsHelp, setIsShowingCostsHelp] = useState(false);
	const [helpCode, setHelpCode] = useState();
	const [disableTextReminders, setDisableTextReminders] = useState(false);
	const [keepExpensesDiary, setKeepExpensesDiary] = useState(
		yourControlSettings.keepExpensesDiary
	);
	const [reminders, setReminders] = useState(yourControlSettings.reminders);

	// -- Required for Day of Week selection
	// const dayNumbers = [1, 2, 3, 4, 5, 6, 0];

	// const days = dayNumbers.map((e) => {
	// 	const day = getDayAbbreviation(e);

	// 	const name = `dayOfWeek${e}`;

	// 	const element = (<><Field type="radio"
	// 		name="dayOfWeek"
	// 		id={name}
	// 		className={"hidden radioOption"}
	// 		value={name}
	// 		checked={dayOfWeek === e}
	// 		onClick={(w) => setDayOfWeek(e)} />

	// 		<label htmlFor={name} className="text-xs sm:text-lg option rounded-md p-1 cursor-pointer flex items-center justify-center transition duration-300">{day}</label></>);

	// 	return element;
	// });

	const handleShowHelp = (helpCode) => {
		setHelpCode(helpCode);
		setIsShowingCostsHelp(true);
	};

	useEffect(() => {
		const userPid = getUserPid();
		if (userPid.mobilePhone) {
		} else {
			setDisableTextReminders(true);
		}
	}, []);

	const onNext = () => {
		// -- Required for 'Day of Week' selection
		// yourControlSettings.dayOfWeek = dayOfWeek;
		yourControlSettings.experienceOffset = experienceOffset;

		yourControlSettings.keepExpensesDiary = keepExpensesDiary;
		yourControlSettings.reminders = reminders;

		return new Promise((resolve) => {
			yourControlSettings.complete = true;

			saveYourControl(yourControlSettings)
				.then(resolve)
				.catch((error) => {
					if (props.onSaveFailure) {
						props.onSaveFailure(error);
					}
					resolve();
				});
		});
	};

	const hideNext = () => {
		return keepExpensesDiary === null || reminders === null;
	};

	const headerDetails = {
		title: "Your Control",
		currentPage: 2,
		pageCount: 3,
	};

	return (
		<>
			<SetupDataPageTemplate
				headerDetails={headerDetails}
				backTo={`${pathRoot}/1`}
				nextTo={`${pathRoot}/3`}
				onClickBack={resetUserSettings}
				onClickNext={{ async: true, func: onNext }}
				// nextTextOverride={"Finish"}
				hideNext={hideNext()}
			>
				<Form schema={schema}>
					<h2 className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
						Do you wish to keep a diary of your expenses?
					</h2>
					<div className={"flex"}>
						<div className={"flex-grow"}>
							<p
								className={
									"mb-4 text-sm lg:text-base leading-tight lg:leading-6 pr-2"
								}
							>
								If not, choose no and we'll tidy it away completely.
							</p>
						</div>
					</div>

					<div className={"w-56"}>
						<div className={`radioSlider`}>
							<Field
								type="radio"
								name="expenses"
								id="expensesYes"
								className={"hidden radioOption"}
								value={"expensesYes"}
								checked={keepExpensesDiary === true}
								onClick={() => setKeepExpensesDiary(true)}
							/>
							<label
								htmlFor={"expensesYes"}
								className={`option ${
									keepExpensesDiary
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								Yes
							</label>

							<Field
								type="radio"
								name="expenses"
								id="expensesNo"
								className={"hidden radioOption"}
								value={"expensesNo"}
								checked={keepExpensesDiary === false}
								onClick={() => setKeepExpensesDiary(false)}
							/>
							<label
								htmlFor={"expensesNo"}
								className={`option ${
									!keepExpensesDiary
										? `bg-black text-white font-medium`
										: "bg-gray-100"
								}`}
							>
								No
							</label>
						</div>
					</div>

					<div className={"w-full mx-auto space-y-2 mb-4 sm:mb-6 mt-3"}>
						<HelpButtonExpanded
							onClick={() => handleShowHelp("Home.setup.cost")}
							text={"Diary of Expenses Info"}
							linkColorOverride="text-app-midblue"
							textSizeOverride="text-md"
						/>
					</div>

					<h2 className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
						How should we send you reminders?
					</h2>
					<p className={"mb-4 text-sm lg:text-base leading-tight lg:leading-6"}>
						How would you prefer to receive reminders outside of the Health
						Companion:
					</p>

					<div className={`radioSlider`}>
						<Field
							type="radio"
							name="reminders"
							id="remindersEmail"
							className={"hidden radioOption"}
							checked={reminders === 0}
							onClick={() => setReminders(0)}
						/>
						<label
							htmlFor={"remindersEmail"}
							className={`option ${
								reminders === 0
									? `bg-black text-white font-medium`
									: "bg-gray-100"
							}`}
						>
							By email
						</label>

						<Field
							type="radio"
							name="reminders"
							id="remindersText"
							className={"hidden radioOption"}
							checked={reminders === 1}
							onClick={() => setReminders(1)}
							disabled={disableTextReminders}
						/>
						<label
							htmlFor={"remindersText"}
							className={`option ${
								reminders === 1
									? `bg-black text-white font-medium`
									: disableTextReminders
									? "bg-gray-50 text-gray-300"
									: "bg-gray-100"
							}`}
						>
							By text msg
						</label>

						<Field
							type="radio"
							name="reminders"
							id="remindersBoth"
							className={"hidden radioOption"}
							checked={reminders === 2}
							onClick={() => setReminders(2)}
							disabled={disableTextReminders}
						/>
						<label
							htmlFor={"remindersBoth"}
							className={`option ${
								reminders === 2
									? `bg-black text-white font-medium`
									: disableTextReminders
									? "bg-gray-50 text-gray-300"
									: "bg-gray-100"
							}`}
						>
							Both
						</label>
					</div>
				</Form>
			</SetupDataPageTemplate>

			<HelpPopup
				show={isShowingCostsHelp}
				onClose={() => setIsShowingCostsHelp(false)}
				bgColor={"lcnuk-primary"}
				helpCode={helpCode}
			/>
		</>
	);
}
